//
//
//
//
//
//
//
//

export default {
  name: "SidebarLogo"
};